import { ButtonFormField, TitleFieldViewModel  } from "@sitecore-jss/sitecore-jss-forms";
import { FieldProps } from "@sitecore-jss/sitecore-jss-react-forms";

export type TButtonFormField = FieldProps<
ButtonFormField & {
    model: TitleFieldViewModel & {
        navigationStep: number;
    }
  }
>;

export enum ButtonClassNames {
  Previous = "sitecore-jss-form__button--previous",
  Next = "sitecore-jss-form__button--next",
  Submit = "sitecore-jss-form__button--submit"
}